import connectUrl from 'commons/js/components/connectUrl'
import VehicleInspectionProductSelectorContainer from './VehicleInspectionProductSelectorContainer'

function mapParamsToProps (_, queryParams) {
    return {
        initialVehicleFilter: queryParams.vehicle_filter,
    }
}

export default connectUrl(mapParamsToProps)(VehicleInspectionProductSelectorContainer)
